import { FieldViewModel, IGenericAnalysisAlloc, ISoilAnalysisAlloc } from "../../../omnia"
import { IDataLayerZone, ISoilService } from "../../../types"
import { IAnalysisLayerData } from "../map/analysis-layer"
import { GlobalAnalysisAlloc } from "./alloc-vm"
import { GlobalSoilAnalysisVM } from "./soilanalysis-vm"

export class GlobalSoilAnalysisAlloc extends GlobalAnalysisAlloc {

    public field: FieldViewModel;
    public zone: IDataLayerZone;

    static createFromAlloc(svc: ISoilService,
        analysis: GlobalSoilAnalysisVM,
        allocation: IGenericAnalysisAlloc) {

        var a = new GlobalSoilAnalysisAlloc()
        a.analysis = analysis
        a.allocation = allocation
        a.field = svc.findField(allocation.FieldId)

        return a;
    }

    static createAlloc(analysis: GlobalSoilAnalysisVM, data: IAnalysisLayerData): GlobalSoilAnalysisAlloc {
        var a = new GlobalSoilAnalysisAlloc();
        a.analysis = analysis;
        a.field = data.field;
        a.zone = data.zone;
        a.layerData = data;
        a.shown = true;

        if (a.zone) {
            var zAllocation = analysis.analysis.Allocations.filter(l => l.FieldId === data.field.fieldId &&
                l.ZoneId === a.zone.DataLayerZoneId && (<ISoilAnalysisAlloc>l).ZoneAlloc);
            if (zAllocation.length) {
                a.allocation = zAllocation[0];
            }
        } else {
            var allocation = analysis.analysis.Allocations.filter(l => l.FieldId === data.field.fieldId &&
                !(<ISoilAnalysisAlloc>l).ZoneAlloc);
            if (allocation.length) {
                a.allocation = allocation[0];
            }
        }

        return a;
    }

    getDescription(): string {
        return this.zone ? this.field.description + " - Zone: " + this.zone.Number : this.field.description;
    }

    getId(): any {
        return this.field ? this.zone ? this.field.fieldId + " " + this.zone.DataLayerZoneId : this.field.fieldId : null;
    }

}
